<template>
		<div class="content">
		<Header></Header>
	     <div class="container level-container">
	     	<div class="level-bg"></div>
	     	<div class="title">{{$t('select_level')}}</div>
	     	<div class="cards">
	     		<div class="level-card level-card--green" @click="chooseBeginner(1)">
	     			<img class="level-img" src="../../static/images/home-img1.png" alt="beginner">
	     			<div class="level-text">{{$t('select_level_tip1')}}</div>
	     		</div>
	     		<div class="level-card level-card--purple" @click="chooseBeginner(3)">
	     			<img class="level-img" src="../../static/images/home-img2.png" alt="some">
	     			<div class="level-text">{{$t('select_level_tip2')}}</div>
	     		</div>
	     	</div>
	     </div>
		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:[]

		}
    },
	created(){

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		chooseBeginner(level){
      let that =this;
      if (level >=3){
        that.$parent.loadModal(true);
        that.$api.post('/api/level/update', {'level':level},r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if (r.data.level >= 3){
              that.$router.push({path:'/'});
            }else {
              that.$router.push({path:'/leveltest'});
            }
          });

        })
      }else {
        that.$router.push({path:'/leveltest'});
      }


		},
	}
}
</script>
<style  scoped>
.content{
  padding-top: 140px
}
.level-container{
	position: relative;
	padding: 24px 20px 40px;
}
.level-bg{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: radial-gradient(160px 160px at 20% 10%, rgba(255, 192, 203, .25), transparent 60%),
		radial-gradient(220px 220px at 80% -20%, rgba(255, 182, 193, .35), transparent 60%),
		rgba(255,255,255,1);
	z-index: 0;
}
.title{
	position: relative;
	z-index: 1;
	text-align: center;
	font-weight: 700;
	font-size: 50px;
	margin: 36px 0 28px;
}
.cards{
	position: relative;
	z-index: 1;
	display: flex;
	flex-direction: column;
	gap: 80px;
  align-items: center;
  margin-top: 100px;
}
.level-card{
  width: 80%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	padding: 24px;
	height: 300px;
	border-radius: 28px;
	box-shadow: 0 20px 30px rgba(0,0,0,0.10);
	color: #fff;
	cursor: pointer;
	transition: transform .12s ease, box-shadow .12s ease;
}
.level-card:active{ transform: scale(.98); box-shadow: 0 12px 22px rgba(0,0,0,0.12); }
.level-card--green{
	background: linear-gradient(180deg, #2fcf7a 0%, #0fb26a 100%);
}
.level-card--purple{
	background: linear-gradient(180deg, #9061f3 0%, #6b3fd6 100%);
}
.level-img{
	width: 200px;
	height:  200px;
	flex-shrink: 0;
}
.level-text{
	font-size: 30px;
	font-weight: 800;
	line-height: 1.35;
	text-align: center;
	text-shadow: 0 2px 4px rgba(0,0,0,0.15);
}
</style>



// WEBPACK FOOTER //
// src/page/level.vue